export default function validateFPEmail(values) {
  let errors = {};

  if (!values.verificationEmail) {
    errors.verificationEmail = "Email address is required";
  } else if (!/\S+@\S+\.\S+/.test(values.verificationEmail)) {
    errors.verificationEmail = "Email address is invalid";
  }

  return errors;
}
